<!--充电机数据 -->
<template>
  <div>
    <!-- 列表 -->
    <div id="btUpdateInfo" style="position: relative;">
      <el-table id="btUpdateInfoTable" v-loading="loading" :data="tableData" style="width: 100%" border>
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-position="left" inline class="demo-table-expand" style="padding-left: 50px;">

              <el-form-item :label="$t('yhubReport.Charge')">
                <span>{{ scope.row.AhOut }} Ah</span>
              </el-form-item>

              <el-form-item :label="$t('lithiumWarn.ChargerMalfunction')">
                <span>{{ scope.row.ErrorCode }}</span>
              </el-form-item>

              <el-form-item :label="$t('charger.charger_temp')">
                <span>{{ scope.row.InnerTemp }} </span>
              </el-form-item>

              <el-form-item :label="$t('QR.ACVoltage')">
                <span>{{ scope.row.VoltageInput }} V</span>
              </el-form-item>

              <el-form-item :label="$t('chargeEvent.m_f')">
                <span>{{ scope.row.Frequency }} Hz</span>
              </el-form-item>

              <!-- <el-form-item :label="$t('chargeEvent.b_p')">
                <span>{{ scope.row.Soc }} %</span>
              </el-form-item> -->

              <el-form-item :label="$t('yhubReport.index')">
                <span>{{ scope.row.ChargedCycle }}</span>
              </el-form-item>

              <el-form-item :label="$t('charger.remaining')">
                <span>{{ scope.row.Remashortime }} {{ $t('dataAndTime.Hours') }}</span>
              </el-form-item>

            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" :label="$t('adminView.UpdateAt')" align="center" min-width="120px" />
        <el-table-column prop="chargerTimeZh" :label="$t('charger.chargerTime')" align="center" min-width="120px" />
        <el-table-column prop="VoltageOut" :label="$t('chargeEvent.o_v')" align="center" />
        <el-table-column prop="CurrentOut" :label="$t('chargeEvent.o_c')" align="center" />
        <el-table-column prop="StageCode" :label="$t('charger.charging_stage')" align="center">
          <template slot-scope="scope">{{ handleStage(scope.row.StageCode) }}</template>
        </el-table-column>
        <!-- <el-table-column prop="InnerTemp" :label="$t('charger.charger_temp')" align="center" /> -->

        <el-table-column prop="BattVoltage" :label="$t('warningPage.Voltage')" align="center" />
        <el-table-column prop="Soc" :label="$t('chargeEvent.b_p')" align="center">
          <template slot-scope="scope">{{ scope.row.Soc }} %</template>
        </el-table-column>

        <el-table-column prop="BattTemp" :label="$t('charger.innerTem')" align="center" />
        <el-table-column prop="FwVersion" :label="$t('adminView.FirmwareVersion')" align="center" />
        <el-table-column prop="CurveNumber" :label="$t('adminView.CurveNo')" align="center" />
        <el-table-column prop="createBy" :label="$t('QR.Uploader')" align="center" />
      </el-table>
      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination
            v-if="pageshow"
            background
            current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery.pageInfo.pageList"
            :page-size="listQuery.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listQuery.pageInfo.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { chargerPage, pageBluetoothDetail } from '@/api/blueTooth'
import { pagination } from '@/utils/init_table'
// import i18n from '@/i18n'
import { getDateAndHour, howLongAgo } from '@/utils/updateTime.js'
import { temChangeUnit } from '@/utils/temChange.js'

export default {
  props: {
    activeTab: {
      type: String,
      default: ''
    },
    selectDay: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end,
      loading: true,
      tableData: []
    }
  },
  watch: {
    activeTab(newValue, oldValue) {
      if (newValue == 'btUpdateInfoPane') this.queryList()
    },
    selectDay(newValue, oldValue) {
      if (this.activeTab == 'btUpdateInfoPane') this.queryList()
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    handleStage(val) {
      // if (val == 1) return '充电阶段'
      if (val == 2) return this.$t('charger.bulk_stage')
      if (val == 3) return this.$t('charger.absorption_stage')
      if (val == 4) return this.$t('charger.finish_stage')
      if (val == 5) return this.$t('charger.end_charging')
      return '--'
    },
    queryList() {
      var param = {
        'endDate': '',
        'mcuId': this.$route.query.chargerSn,
        'showAll': false,
        'startDate': '',
        'type': 2,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      this.loading = true
      // console.log(this.selectDay)
      if (this.selectDay && this.selectDay.length > 0) {
        param.startDate = new Date(this.selectDay[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDay[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1
      }
      pageBluetoothDetail(param).then(res => { // 基本信息
        this.loading = false
        if (res.resultCode === 1001 && res.resultModel) {
          this.tableData = []
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          if (!res.resultModel.list) return
          res.resultModel.list.forEach(v => {
            var jsonDataObj = JSON.parse(v.jsonData)
            jsonDataObj.updateTime = v.yhubTime ? getDateAndHour(v.yhubTime) : '--'
            jsonDataObj.chargerTimeZh = jsonDataObj.chargerSystemTime ? getDateAndHour(jsonDataObj.chargerSystemTime) : '--'
            jsonDataObj.VoltageOut = jsonDataObj.VoltageOut + ' V'
            jsonDataObj.CurrentOut = jsonDataObj.CurrentOut + ' A'
            jsonDataObj.BattTemp = temChangeUnit(jsonDataObj.BattTemp)
            jsonDataObj.InnerTemp = temChangeUnit(jsonDataObj.InnerTemp)
            jsonDataObj.BattVoltage = jsonDataObj.BattVoltage + ' V'
            jsonDataObj.FwVersion = 'V' + jsonDataObj.FwVersion
            jsonDataObj.createBy = v.createBy
            this.tableData.push(jsonDataObj)
            // for(var attr in jsonDataObj){
            //   this.tableData.push({
            //     VoltageOut:jsonDataObj[jsonDataObj]/100
            //   })
            // }
          })
        }
      })
    },
    // 筛选改变事件
    changeSearch() {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange(val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end

  }
}
</script>
